import dayjs from '@/libs/dayjs';

export const isFinished = (event?: ImEventDto) => {
  const finished = dayjs(event?.endsAt).isBefore(
    dayjs().add(-1, 'day').endOf('day')
  );
  return finished;
};
